import { render, staticRenderFns } from "./clientesEspecificos.vue?vue&type=template&id=5d9c6e71"
import script from "./clientesEspecificos.vue?vue&type=script&lang=js"
export * from "./clientesEspecificos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports